const DEFAULT_FLASH_PAGINATION_ID_PREFIX = "flash-pagination", DEFAULT_PAGINATION_ITEMS_PER_PAGE_OPTIONS = [10, 30, 50, 100];
export {
  DEFAULT_FLASH_PAGINATION_ID_PREFIX,
  DEFAULT_PAGINATION_ITEMS_PER_PAGE_OPTIONS
};
//# sourceMappingURL=constants.js.map
